<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Groups</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
    </span>
    <form-wrapper>
      <b-form @submit="onSubmit">
        <b-form-group>
          <label for="id">Group ID</label>
          <input
            id="id"
            :value="group.id"
            disabled
            class="form-control"
            type="text"/>
        </b-form-group>

        <b-form-group>
          <label for="name-input">Name</label>
          <b-form-input
            v-validate="'required'"
            id="name-input"
            :disabled="saving"
            :class="{ 'is-invalid' : errors.has('name') || apiErrors.name.length }"
            :value="fields.name === null ? group.name : fields.name"
            class="form-control"
            type="text"
            name="name"
            @input="setName"/>
          <validation-errors :validation-errors="[errors.first('name')]"/>
          <validation-errors v-if="!errors.has('name')" :validation-errors="apiErrors.name"/>
        </b-form-group>

        <b-form-group>
          <label for="description-input">Description</label>
          <b-form-textarea
            v-validate="'required'"
            id="description-input"
            :disabled="saving"
            :class="{ 'is-invalid' : errors.has('description') || apiErrors.description.length }"
            :rows="3"
            :max-rows="6"
            :value="fields.description === null ? group.description : fields.description"
            type="text"
            name="description"
            @input="setDescription"/>
          <validation-errors :validation-errors="[errors.first('description')]"/>
          <validation-errors v-if="!errors.has('description')" :validation-errors="apiErrors.description"/>
        </b-form-group>

        <relate-modules
          :initial-modules="group.modules"
          :disabled="saving"
          namespace="groups"/>

        <relate-members
          :initial-members="group.members"
          :disabled="saving"
          namespace="groups"/>

        <b-form-group class="form-buttons">
          <b-button :disabled="saving" variant="secondary" @click="$router.push({name: 'admin-groups'})">
            Cancel
          </b-button>
          <b-button :disabled="disabled" type="submit" variant="primary">
            Confirm
            <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
          </b-button>
        </b-form-group>

        <form-success :success="success" class="form-alert">Group Updated!</form-success>
      </b-form>
    </form-wrapper>
  </page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'
import page from '../../../templates/page'
import relateModules from '../modules/relateModules'
import relateMembers from '../members/relateMembers'
import sidebar from '../../../sidebar'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    formSuccess,
    formWrapper,
    page,
    relateModules,
    relateMembers,
    sidebar,
    validationErrors
  },
  data () {
    return {
      breadcrumbs: [{
        text: 'Groups',
        to: { name: 'admin-groups' }
      },
      {
        text: 'Edit',
        active: true
      }]
    }
  },
  computed: {
    ...mapState('groups', {
      group: 'current'
    }),
    ...mapState('groups/forms/update', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    ...mapState('config', {
      apiConfig: 'data'
    }),
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  watch: {
    success (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.resetFields()
      }
    }
  },
  created() {
    this.$store.commit('groups/forms/update/resetState')
  },
  methods: {
    ...mapActions({
      updateGroup: 'groups/update'
    }),
    onSubmit (event) {
      event.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateGroup({
            groupID: this.group.id
          })
        }
      })
    },
    setName (event) {
      this.$store.commit('groups/forms/update/setField', {
        field: 'name',
        value: event
      })
    },
    setDescription (event) {
      this.$store.commit('groups/forms/update/setField', {
        field: 'description',
        value: event
      })
    },
    reset (event) {
      this.errors.clear()
    },
    resetFields (event) {
      this.reset()
      this.$store.commit('groups/forms/update/resetFields')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/groups/edit.vue